import React, { Component } from 'react';
import $ from 'jquery';
import { Doughnut, Pie, Bar } from 'react-chartjs-2';
import { Line } from "react-chartjs-2";
import { Collapse } from 'react-collapse';
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function getWeekDays(weekStart) {
    const days = [weekStart];
    for (let i = 1; i < 7; i += 1) {
        days.push(
            moment(weekStart)
                .add(i, 'days')
                .toDate()
        );
    }
    return days;
}

function getWeekRange(date) {
    return {
        from: moment(date)
            .startOf('week')
            .toDate(),
        to: moment(date)
            .endOf('week')
            .toDate(),
    };
}

class WeeklyTtsUsageReport extends Component {
    constructor() {
        super();
        this.state = {
            displayTTSByDay: true,
            displayTTSByLang: true,
            displayKeyPerformanceByHour: true,
            selectedDays: getWeekDays(getWeekRange(new Date()).from),
            startDate: getWeekRange(new Date()).from.getTime(),
            endDate: getWeekRange(new Date()).to.getTime() - 1,

            // graphData: 
            TTSByDay: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of TTS Usage",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            },

            TTSByLanguage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            },
            totalApiUsageCountData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        label: "# of TTS Usage",
                        borderColor: "#3BA4DC",
                        pointColor: "#fff",
                        responsive: true,
                        pointStrokeColor: "#ccc",
                        pointHoverRadius: 10,
                        backgroundColor: "rgba(60,167,224,0.4)",
                        fill: true
                    }
                ]
            },

            date: null,
            month: '',
            year: '',
        }

    }

    loadData = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var weeklyTTSComponent = this;
        $.ajax({
            url: "/api/tts-weekly-analytics",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                startTime: this.state.startDate,
                endTime: this.state.endDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",

            },

            success: function (res) {
                weeklyTTSComponent.state.showLoader = true;
                if (res.success === true) {
                    weeklyTTSComponent.state.TTSByDay.labels = [];
                    weeklyTTSComponent.state.TTSByDay.datasets[0].data = [];
                    if (res.success === true && res.result.graphData.length !== 0) {
                        for (var i = 0; i < res.result.graphData.length; i++) {
                            weeklyTTSComponent.state.TTSByDay.labels.push(res.result.graphData[i].key);
                            weeklyTTSComponent.state.TTSByDay.datasets[0].data.push(res.result.graphData[i].value);
                        }
                        weeklyTTSComponent.setState(weeklyTTSComponent.state);
                    }

                    weeklyTTSComponent.state.TTSByLanguage.labels = [];
                    weeklyTTSComponent.state.TTSByLanguage.datasets[0].data = [];
                    if (res.success === true && res.result.languageData.length !== 0) {
                        for (var i = 0; i < res.result.languageData.length; i++) {
                            weeklyTTSComponent.state.TTSByLanguage.labels.push(res.result.languageData[i].key);
                            weeklyTTSComponent.state.TTSByLanguage.datasets[0].data.push(res.result.languageData[i].value);
                        }
                        weeklyTTSComponent.setState(weeklyTTSComponent.state);
                    }

                    weeklyTTSComponent.state.totalApiUsageCountData.labels = [];
                    weeklyTTSComponent.state.totalApiUsageCountData.datasets[0].data = [];
                    if (res.success === true && res.result.totalApiUsageCountData.length !== 0) {
                        for (var i = 0; i < res.result.totalApiUsageCountData.length; i++) {
                            weeklyTTSComponent.state.totalApiUsageCountData.labels.push(res.result.totalApiUsageCountData[i].key);
                            weeklyTTSComponent.state.totalApiUsageCountData.datasets[0].data.push(res.result.totalApiUsageCountData[i].value);
                        }
                    }
                    weeklyTTSComponent.setState(weeklyTTSComponent.state)

                }
                else {
                    weeklyTTSComponent.NotifyError()
                }
            }
        });
    }

    NotifyError() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            No Data found</b>, {
            position: "top-center"
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.loadData();
        }, 300);

        var weeklyTTSComp = this;
        document.addEventListener("projectChanged", function (event) {
            weeklyTTSComp.projectId = event.projectId;
            weeklyTTSComp.loadData(event.projectId);
        });
    }

    refreshData = () => {
        this.loadData()
    }

    resetData = () => {
        this.handleDayChange(new Date());
    }

    displayTTSByDay = () => {
        this.state.displayTTSByDay ? this.setState({ displayTTSByDay: false }) :
            this.setState({ displayTTSByDay: true });
    }

    displayTTSByLang = () => {
        this.state.displayTTSByLang ? this.setState({ displayTTSByLang: false }) :
            this.setState({ displayTTSByLang: true });
    }

    displayKeyPerformanceByHour = () => {
        this.state.displayKeyPerformanceByHour ? this.setState({ displayKeyPerformanceByHour: false }) :
            this.setState({ displayKeyPerformanceByHour: true });
    }

    handleDayChange = date => {
        this.state.selectedDays = getWeekDays(getWeekRange(date).from);
        this.state.startDate = getWeekRange(date).from.getTime();
        this.state.endDate = getWeekRange(date).to.getTime() - 1;
        this.setState(this.state);
        this.loadData();
    };

    render() {
        const { selectedDays } = this.state;

        return (
            <div>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                <title>Dheeyantra | Dashboard </title>
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Theme style */}
                <link rel="stylesheet" href="dist/css/adminlte.css" />
                <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/custom-style.css" />
                <div className="wrapper">

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item"
                                    style={{ color: '#282a65', marginTop: '10px', marginLeft: '7px' }}>
                                    Weekly TTS Usage Data
                                </h6></div>

                            <div className="d-flex flex-row-reverse pt-2 col-sm-6" style={{ backgroundColor: '#F9F9FB' }}>
                                <button
                                    className="btn action-button"
                                    title="refresh"
                                    onClick={this.refreshData}>
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>

                                <button className="btn action-button"
                                    onClick={this.resetData}>
                                    Reset
                                </button>

                                <DatePicker
                                    selected={selectedDays[0]}
                                    onChange={this.handleDayChange}
                                    startDate={selectedDays[0]}
                                    endDate={selectedDays[6]}
                                    dateFormat="dd/MM/yyyy"
                                />

                            </div>
                        </div>
                    </div>
                    {/* Custom Tabs */}
                    <div className="col-12">
                        {/* /.card-header */}
                        <div className="card-body p-0 mb-25">
                            <div className="tab-content col-12 p-0">
                                <div className="tab-pane active show" id="tab_1">
                                    {/* Main content */}
                                    <div className="content">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <h6>
                                                    <img src={this.state.displayTTSByDay ? './assets/images/downward_arrow.png' :
                                                        './assets/images/rightward_arrow.png'}
                                                        onClick={this.displayTTSByDay} />TTS Usage by Week</h6>
                                                <div className="col-lg-12">
                                                    <Collapse isOpened={this.state.displayTTSByDay}>

                                                        <div className="card filled-line-chart">
                                                            <div className="card-body">
                                                                <div className="position-relative mb-4">
                                                                    {/* <canvas id="line-chart" style={{ "height": "197px" }} /> */}
                                                                    <Line data={this.state.TTSByDay} width="1000" height="250" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                                <div className="col-lg-12">
                                                    <h6 style={{marginLeft:'-9px'}}>
                                                        <img src={this.state.displayTTSByLang ? './assets/images/downward_arrow.png' :
                                                            './assets/images/rightward_arrow.png'}
                                                            onClick={this.displayTTSByLang} />TTS Usage by Language</h6><br />
                                                    <Collapse isOpened={this.state.displayTTSByLang}>

                                                        <div className="col-lg-3" />
                                                        <div className="col-lg-6">
                                                            <div className="card monthly-conversation-chart">
                                                                <div className="card-body">
                                                                    <div className="chartHeight">
                                                                        <Pie data={this.state.TTSByLanguage} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* /.card */}
                                                        </div>
                                                        <div className="col-lg-3" />
                                                    </Collapse>
                                                </div>

                                                <div className="col-lg-12">
                                                    <h6 style={{marginLeft:'-9px',marginTop:'-14px'}}>
                                                        <img src={this.state.displayKeyPerformanceByHour ? './assets/images/downward_arrow.png' :
                                                            './assets/images/rightward_arrow.png'}
                                                            onClick={this.displayKeyPerformanceByHour} />Per Day API Usage Count<br /><br />
                                                    </h6>
                                                    <Collapse isOpened={this.state.displayKeyPerformanceByHour}>

                                                        <div className="card filled-line-chart">
                                                            <div className="card-body">
                                                                <div className="position-relative mb-4">
                                                                    {/* <canvas id="line-chart" style={{ "height": "197px" }} /> */}
                                                                    <Bar data={this.state.totalApiUsageCountData} width="1000" height="250" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                    <ToastContainer className="Toast-at-center" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WeeklyTtsUsageReport;


// WEBPACK FOOTER //
// ./src/ttsUi/reports/WeeklyTtsUsageReport.js